import vuetify from '@/plugins/vuetify';

/**
 * Sync Vuex isDarkMode → Vuetify 3 theme (replaces Vue 2 $darkMode prototype).
 */
export function setDarkMode(isDark) {
  vuetify.theme.change(isDark ? 'dark' : 'light');
}

export function installDarkModeHelper(app) {
  app.config.globalProperties.$setDarkMode = setDarkMode;

  Object.defineProperty(app.config.globalProperties, '$darkMode', {
    get() {
      return vuetify.theme.global.name.value === 'dark';
    },
    set(value) {
      setDarkMode(value);
    },
  });
}
